import React, { useEffect, useState } from 'react'
import CampoEditable from './CampoEditable'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_ESTIMACION_STOCK } from '../../../../config/forms'
import { connect } from 'react-redux'
import { updateEspacioDisponibleElevador, actualizarEstimacionSemanal } from '../../actions/listados'

function EspacioDisponible (props) {
  const { change: formChange, espacioDisponibleElevador, espacioDisponible } = props
  const [cantidad, setCantidad] = useState(espacioDisponible)

  useEffect(() => {
    setCantidad(espacioDisponible)
  }, [espacioDisponible])

  const handleInputBlur = async () => {
    if (espacioDisponibleElevador && espacioDisponibleElevador !== cantidad) {
      const newValue = !isNaN(espacioDisponibleElevador) ? parseInt(espacioDisponibleElevador) : null
      props.updateEspacioDisponibleElevador(newValue)
      setCantidad(newValue)
      props.actualizarEstimacionSemanal()
    }
  }

  const handleDisplayClick = () => {
    formChange('espacioDisponibleElevador', cantidad)
  }

  return (
    <CampoEditable
      titulo='Espacio disponible en camiones (01 hs)'
      name='espacioDisponibleElevador'
      handleInputBlur={handleInputBlur}
      handleDisplayClick={handleDisplayClick}
      valor={cantidad ? `${cantidad}` : ' - '}
      backgroundColor={'#7b96d3'}
    />
  )
}

const selector = formValueSelector(FORM_ESTIMACION_STOCK)
const mapStateToProps = (state) => ({
  espacioDisponibleElevador: selector(state, 'espacioDisponibleElevador'),
  espacioDisponible: state.stock.espacioDisponibleElevador
})

const mapActionsToProps = {
  actualizarEstimacionSemanal,
  updateEspacioDisponibleElevador
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
const withReduxForm = reduxForm({
  form: FORM_ESTIMACION_STOCK,
  destroyOnUnmount: false
})

export default withRedux(withReduxForm(EspacioDisponible))
